import * as React from 'react';
import AllocateDetails from './Allocate';
import AllocateTeamToTruck from './AllocateTeamToTruck';
import * as DateHelpers from './DateHelpers';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions } from './Shared';

const AllocateData = () => {
    let navigate = useNavigate();
    const [scheduleDate, setScheduleDate] = React.useState("");
    const [scheduleDateFormatted, setScheduleDateFormatted] = React.useState("");
    const [scheduleBranchId, setScheduleBranchId] = React.useState(-1);
    const [itemTypeGroupFilterId, setItemTypeGroupFilterId] = React.useState(1);
    const [tab, setTab] = React.useState("Allocate");
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        //set tomorrow as the default schedule date
        var date = DateHelpers.addDaysToCurrentDate(1);
        if (DateHelpers.isCurrentDayFriday()) {
            //need to set schedule date to monday
            date = DateHelpers.addDaysToCurrentDate(3);
        }
        setScheduleDate(date);
        var dateFormatted = DateHelpers.formatDate(date);
        setScheduleDateFormatted(dateFormatted);

        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("ViewAllocation");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied");
        }
    }

    const updateScheduleDate = (updatedScheduleDate: string) => {
        var scheduleDateFormatted = DateHelpers.formatDate(updatedScheduleDate);
        setScheduleDate(updatedScheduleDate);
        setScheduleDateFormatted(scheduleDateFormatted);
    }

    const updateItemTypeGroupFilter = (filterId: number) => {
        setItemTypeGroupFilterId(filterId);
    }

    const goAllocateTruck = (schedBranchId: number) => {
        setTab("AllocateTruck");
        setScheduleBranchId(schedBranchId);
    }

    const goAllocate = () => {
        setTab("Allocate");
    }

    let contents;
    if (tab == "Allocate") {
        contents = <AllocateDetails scheduleDate={scheduleDate} scheduleDateFormatted={scheduleDateFormatted} scheduleBranchId={scheduleBranchId} itemTypeGroupFilterId={itemTypeGroupFilterId} updateScheduleDate={updateScheduleDate} updateItemTypeGroupFilter={updateItemTypeGroupFilter} goAllocateTruck={goAllocateTruck} />
    }
    else if (tab == "AllocateTruck") {
        contents = <AllocateTeamToTruck scheduledDate={scheduleDate} back={goAllocate} save={goAllocate} />
    }

    const renderDetails = (
        <div>
            <div className="tabsComponent" id="tab-container">
                <div>
                    {contents}
                </div>
            </div>

        </div>
    );

    let screenContents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {screenContents}
        </div>
    );

};

export default AllocateData;